module.exports = __webpack_public_path__ + "static/subscribe-pattern-e463f88e3b2788bd4d4e8286db1a5283.png";